import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Card from "../../../ui/Card";
import styled from "@emotion/styled/macro";
import { NavLink } from "react-router-dom";
import abroad from "../../../../assets/images/abroad.svg";
import accident from "../../../../assets/images/accident.svg";
import verification from "../../../../assets/images/verification.svg";
import insurance from "../../../../assets/images/insurance.svg";
import { filterMenuBasedOnCms } from "../../../../helpers/helpers";

const Wrapper = styled.div`
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    flex-wrap: wrap;
  }
  display: flex;
  flex-direction: column;
  ul {
    list-style-type: none;
  }
`;

const CardWrapper = styled.div`
  margin-bottom: 1em;
  width: 100%;
  z-index: 1;
  position: relative;
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    width: 20em;
  }
`;

const Cards = ({ cards }) => {
  const { i18n } = useTranslation();
  const { language } = i18n;

  const [filteredCards, setFilteredCards] = useState();

  const cardList = [
    {
      card: "abroad",
      icon: abroad,
      cmsId: "abroad",
    },
    { card: "accident", icon: accident, cmsId: "accident" },
    { card: "verification", icon: verification, cmsId: "access" },
    { card: "insurance", icon: insurance },
  ];

  const cardsToShow = cardList.filter((card) => cards.includes(card.card));

  useEffect(() => {
    const filterMenu = async () => {
      const result = await filterMenuBasedOnCms(cardsToShow, language);
      setFilteredCards(result);
    };
    filterMenu(); // eslint-disable-next-line
  }, []);

  return (
    <Wrapper>
      {filteredCards?.map((card) => (
        <CardWrapper>
          <NavLink to={`/${card.card}`}>
            <Card card={card.card} icon={card.icon} />
          </NavLink>
        </CardWrapper>
      ))}
    </Wrapper>
  );
};

export default Cards;
